import { useContext, useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { Context } from "../../Context/Context";
import "./TopBar.css";

// Tiêu đề trang hiển thị ngay trên header, để trang không phải tốn một hàng
// riêng cho tiêu đề. Route nào chưa khai báo ở đây thì header giữ nguyên như
// cũ (chỉ có phần bên phải) — thêm trang mới chỉ cần thêm 1 dòng.
const PAGE_TITLES = {
  "/bookings": {
    icon: "fas fa-book",
    title: "Sổ thuê acc",
    subtitle: "Quản lý các phiếu cho thuê tài khoản",
  },
};

export default function TopBar({ onMobileMenuToggle, isMobileMenuOpen }) {
  const { user, dispatch, ToggleSetPwd } = useContext(Context);
  const { pathname } = useLocation();
  const pageTitle = PAGE_TITLES[pathname];
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Theme state from localStorage
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("admin-theme") || "dark";
  });

  // Apply theme on mount and change
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("admin-theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === "dark" ? "light" : "dark");
  };

  const handleLogout = () => {
    dispatch({ type: "LOGOUT" });
    setIsDropdownOpen(false);
  };

  const handleToggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleCreateAccount = () => {
    setIsDropdownOpen(false);
  };

  const handleChangePassword = () => {
    ToggleSetPwd();
    setIsDropdownOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);

  return (
    <div className="topbar">
      {/* Mobile hamburger */}
      <button 
        className={`mobile-hamburger ${isMobileMenuOpen ? 'active' : ''}`} 
        onClick={onMobileMenuToggle}
        aria-label="Toggle menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      {pageTitle && (
        <div className="topbar-title">
          <span className="topbar-title-icon"><i className={pageTitle.icon}></i></span>
          <div className="topbar-title-text">
            <div className="topbar-title-name">{pageTitle.title}</div>
            {pageTitle.subtitle && <div className="topbar-title-sub">{pageTitle.subtitle}</div>}
          </div>
        </div>
      )}

      <div className="topbar-right">
        {/* Theme Toggle */}
        <button className="theme-toggle" onClick={toggleTheme} title={theme === "dark" ? "Chế độ sáng" : "Chế độ tối"}>
          <i className={`fas ${theme === "dark" ? "fa-sun" : "fa-moon"}`}></i>
        </button>

        {user && (
          <div className="user-profile-container" ref={dropdownRef}>
            <div className="user-profile" onClick={handleToggleDropdown}>
              <img
                className="user-avatar"
                src="https://images.unsplash.com/photo-1517849845537-4d257902454a"
                alt="User Avatar"
              />
              <div className="user-info">
                <div className="user-name">Admin</div>
                <div className="user-role">Quản trị viên</div>
              </div>
              <i className={`fas fa-chevron-down user-arrow ${isDropdownOpen ? 'rotated' : ''}`}></i>
            </div>

            {/* Dropdown Menu */}
            {isDropdownOpen && (
              <div className="user-dropdown">
                <Link to="/write" className="dropdown-item" onClick={handleCreateAccount}>
                  <i className="fas fa-plus"></i>
                  <span>Tạo tài khoản</span>
                </Link>
                <button className="dropdown-item" onClick={handleChangePassword}>
                  <i className="fas fa-key"></i>
                  <span>Đổi mật khẩu</span>
                </button>
                <button className="dropdown-item logout-item" onClick={handleLogout}>
                  <i className="fas fa-sign-out-alt"></i>
                  <span>Đăng xuất</span>
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
